"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataService = void 0;
const calculator_service_1 = require("./calculator.service");
const BASE_PATH = "https://www.descartes.com/apps/fcc/php";
class DataService {
    constructor() {
        this.fuelRates = [
            {
                code: "US",
                country: "USA",
                gasoline: 0.738,
                diesel: 0.714,
                currency: "USD",
                exrate: 1,
                exrateEuro: 0.827849,
            },
        ];
        this.countries = [
            {
                value: "US",
                label: "United States",
            },
        ];
        this.http = {
            get(url) {
                return new Promise((resolve, reject) => {
                    const http = new XMLHttpRequest();
                    http.open("GET", url, true);
                    http.onreadystatechange = () => {
                        if (http.readyState === 4) {
                            if (http.status === 200) {
                                return resolve(http.responseText);
                            }
                            else {
                                reject("Error loading data: " + http.statusText);
                            }
                        }
                    };
                    http.send();
                });
            },
        };
    }
    async loadData() {
        let xml;
        try {
            xml = await this.http.get(`${BASE_PATH}/loadData.php`);
        }
        catch (error) {
            xml = await this.http.get(`${BASE_PATH}/data.xml`);
        }
        const data = this.parseXml(xml);
        this.setData(data);
    }
    isValidCountry(code) {
        return !!this.countries.find((c) => c.value === code);
    }
    parseXml(str) {
        const ret = new Map();
        const parser = new DOMParser();
        const xml = parser.parseFromString(str, "text/xml");
        const children = xml.getElementsByTagName("gpp:element");
        for (let i = 0; i < children.length; i++) {
            const child = children.item(i);
            const item = {
                code: "",
                country: "",
                date: "",
                diesel: 0,
                gasoline: 0,
                currency: "",
                exrate: 0,
                exrateEuro: 0,
            };
            child.childNodes.forEach((node) => {
                switch (node.nodeName) {
                    case "gpp:country":
                        item.country = node.childNodes[0].nodeValue;
                        item.code = node.getAttribute("code");
                        break;
                    case "gpp:date":
                        item.date = node.childNodes[0].nodeValue;
                        break;
                    case "gpp:diesel":
                        item.diesel = parseFloat(node.childNodes[0].nodeValue);
                        break;
                    case "gpp:gasoline":
                        item.diesel = parseFloat(node.childNodes[0].nodeValue);
                        break;
                    case "gpp:currency":
                        item.currency = node.childNodes[0].nodeValue;
                        break;
                    case "gpp:exrate":
                        item.exrate = parseFloat(node.childNodes[0].nodeValue);
                        break;
                    case "gpp:exrateEuro":
                        item.exrateEuro = parseFloat(node.childNodes[0].nodeValue);
                        break;
                }
            });
            let retItem = ret.get(item.code);
            if (!retItem) {
                retItem = {
                    code: item.code,
                };
                ret.set(item.code, retItem);
            }
            [
                "country",
                "diesel",
                "gasoline",
                "currency",
                "exrate",
                "exrateEuro",
            ].forEach((key) => {
                if (item[key] !== 0 && item[key] !== "") {
                    retItem[key] = item[key];
                }
            });
        }
        return Array.from(ret.values());
    }
    setData(data) {
        // Update USA label
        const usa = data.find((rate) => rate.code === "US");
        if (usa) {
            usa.country = "United States";
        }
        this.fuelRates = data;
        this.countries = data.map((rate) => {
            return {
                value: rate.code,
                label: rate.country,
            };
        });
    }
    setCountry(code) {
        for (let i = 0; i < this.countries.length; i++) {
            const country = this.countries[i];
            if (country.value === code) {
                this.country = country;
                break;
            }
        }
    }
    getFuelCost(code) {
        const rateData = this.fuelRates.find((c) => c.code === code);
        let rate = rateData.diesel;
        if (code === "US") {
            // Rate data is per litre, convert to per gallon
            rate = rateData.diesel * calculator_service_1.LITER_PER_GALLON;
        }
        return parseFloat(rate.toFixed(2));
    }
    getCurrencyCode(code) {
        const data = this.fuelRates.find((rate) => rate.code === code);
        if (data) {
            return data.currency;
        }
        else {
            return "?";
        }
    }
    getCurrencySymbol(code) {
        const rateData = this.fuelRates.find((rate) => rate.code === code);
        const locale = rateData.currency === "EUR" ? "fr" : "en";
        return (new Intl.NumberFormat(locale, {
            style: "currency",
            currency: rateData.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
            .formatToParts(1)
            .find((part) => part.type === "currency")?.value || "");
    }
}
exports.DataService = DataService;
